<div class="location-info">
   <div class="summary-header"> Address </div>
   <div>
      <div class="location-info-item">{{ location | ndtStreet }}</div>
      <div class="location-info-item">{{ location.city }}, {{ location.state }} {{ location.postalCode }}</div>
   </div>
   <div class="summary-header"> Comments </div>
   <div>
      <div class="location-info-item">
         {{ location.comment }}
      </div>
   </div>
</div>
